import { render, staticRenderFns } from "./BlockedMsg.vue?vue&type=template&id=47fd24c2&lang=pug"
import script from "./BlockedMsg.vue?vue&type=script&lang=js"
export * from "./BlockedMsg.vue?vue&type=script&lang=js"
import style0 from "./BlockedMsg.vue?vue&type=style&index=0&id=47fd24c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports